import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OnboardingRoutingModule } from './onboarding-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, OnboardingRoutingModule]
})
export class OnboardingModule {}
